import { AppContext } from "./Context.tsx";
import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import ReactGa from "react-ga";
import Themeroutes from "./routes/Router"; // Importing the routes
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

//controllers
import DatabaseRequestController from './i-controllers/DatabaseRequestController.tsx';

function App() {
  //states
  const [staticAppConfig, SetStaticAppConfig] = useState({dburl: 'https://www.ppkm.org.my/mobile_backend/scripts/', secret: 'ppkm_14082024_mobile', build: 0});
  const databaseActionModeQueueRef = useRef([]);
  const [databaseActionModeQueue, SetDatabaseActionModeQueue] = useState(databaseActionModeQueueRef.current);
  const databaseActionParamsQueueRef = useRef([]);
  const [databaseActionParamsQueue, SetDatabaseActionParamsQueue] = useState(databaseActionParamsQueueRef.current);
  const [databaseResultAction, SetDatabaseResultAction] = useState(null);
  const [databaseShouldShowWaitScreen, SetDatabaseShouldShowWaitScreen] = useState(false);

  useEffect(() => {
    ReactGa.initialize("G-ZGDQQS1J71");
    ReactGa.pageview(window.location.pathname);
  }, []);
  const routing = useRoutes(Themeroutes); // Using the imported routes

  return (
    <AppContext.Provider value={{
      staticAppConfig, SetStaticAppConfig,
      databaseActionModeQueueRef, databaseActionModeQueue, SetDatabaseActionModeQueue,
      databaseActionParamsQueueRef, databaseActionParamsQueue, SetDatabaseActionParamsQueue,
      databaseResultAction,
      databaseShouldShowWaitScreen, SetDatabaseShouldShowWaitScreen,
    }}>
      {routing} {/* Rendering the routing based on the routes */}
      <DatabaseRequestController
        databaseActionModeQueueRef={databaseActionModeQueueRef} databaseActionModeQueue={databaseActionModeQueue} SetDatabaseActionModeQueue={SetDatabaseActionModeQueue}
        databaseActionParamsQueueRef={databaseActionParamsQueueRef} databaseActionParamsQueue={databaseActionParamsQueue} SetDatabaseActionParamsQueue={SetDatabaseActionParamsQueue}
        databaseResultAction={databaseResultAction} SetDatabaseResultAction={SetDatabaseResultAction}
        databaseShouldShowWaitScreen={databaseShouldShowWaitScreen}
      />
    </AppContext.Provider>
  );
}

export default App;
